import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"

// On mobile the real search input (and its clear button) live inside the filter
// modal, which is hidden until tapped — so the active query shows in the
// results-page search bar with no inline way to clear it. This restores that:
// empty the modal's input, hide its clear button, and resubmit the search form
// so the results update. Filters live in the same form, so they survive. The
// turbo stream re-renders #search_results (which contains this bar), so the bar
// redraws without the query. preventDefault keeps the button from submitting any
// enclosing form; the bar's "open modal" link is a sibling, so it never fires.
export default class extends Controller {
  clear(event) {
    event.preventDefault()

    const query = document.getElementById("query")
    if (!query) return

    query.value = ""
    document
      .querySelectorAll('[data-search-target="clearButton"]')
      .forEach((button) => button.classList.add("hidden"))

    Rails.fire(query.form, "submit")
  }
}
